// extracted by mini-css-extract-plugin
module.exports = {"page":"SignIn_page__2f9OF","logo":"SignIn_logo__6_oCB","root":"SignIn_root__3_K6l","ob":"SignIn_ob__52msG"};